import React, { Fragment, useEffect } from 'react';
import Modal from 'react-modal';

import SvgIcon from '../Icons';

import './index.sass';


const BasicModal = ({ children,
                      handleClose,
                      hideCloseBtn,
                      mobileFullWidth,
                      modalClass,
                      showModal,
                      scrollable,
                    }) => {

  useEffect(() => {
    showModal ? document.body.classList.add('modal-open') : document.body.classList.remove('modal-open');
  }, [showModal]);

  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0,0,0,0.6)',
      top: '0',
      overflow: 'auto',
      zIndex: '9999',
      backdropFilter: 'blur(5px)',
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      pointerEvents: 'visible',
      background: 'white',
      borderRadius: '4px',
      position: 'absolute',
    },
  };

  return (
    <Modal
      ariaHideApp={false}
      className={`basic-modal ${modalClass || ''} ${mobileFullWidth ? 'mobile-full-width' : ''}`}
      contentLabel={modalClass}
      isOpen={showModal}
      onRequestClose={handleClose || null}
      style={customStyles}
    >
      { scrollable
        ?
        <div className="basic-modal__wrapper">
          { !hideCloseBtn &&
            <div className="basic-modal__close-btn" onClick={handleClose}>
              <SvgIcon name="close" size={24} />
            </div>
          }
          { children }
        </div>
        :
        <Fragment>
          { !hideCloseBtn &&
            <div className="basic-modal__close-btn" onClick={handleClose}>
              <SvgIcon name="close" size={24} />
            </div>
          }
          { children }
        </Fragment>
      }
    </Modal>
  );
};

export default BasicModal;
